
export const shadows = {
  low: ` 0px 2px 10px rgba(90, 90, 90, 0.29)`,
  medium: '0px 8px 24px rgba(48, 47, 47, 0.1)',
};
